import { styled } from '../../Utilities';
import { NavBase } from './Nav.base';
import { getStyles } from './Nav.styles';
export var Nav = styled(NavBase, getStyles, undefined, {
  scope: 'Nav'
});